const TrendingDown = () => (
  <svg width="26" height="25" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle opacity="0.25" cx="13.3633" cy="12.5" r="12.5" fill="#FE3C55" fillOpacity="0.4" />
    <path d="M19.2585 12.2881L19.3418 15.9146L15.5678 15.8346L19.2585 12.2881Z" fill="#FE3C55" stroke="#FE3C55" />
    <path d="M6.86328 9.68933L10.1704 12.8672C10.5575 13.2391 11.1691 13.2391 11.5562 12.8672L13.1704 11.316C13.5575 10.9441 14.1691 10.9441 14.5562 11.316L17.8633 14.4939" stroke="#FE3C55" />
  </svg>
)

export default TrendingDown
